import React, { useEffect, useState } from 'react'
import axiosInstance from '../services/axiosComman';

function useFetchPreReport({url="",value={},hasFilter=false}) {
    const [data, setData] = useState([]);
    const [isLoading, setLoading] = useState(true)
    const [review,setReview] = useState(false);
    const [status,setStatus] = useState({})
    async function getAllData() {
        setLoading(true)

        axiosInstance
          .post(url, value)
          .then((res) => {
            res?.data?.data && setData(res?.data?.data||[]);
            res?.data?.status && setStatus(res?.data?.status||{})
            let dateValue = res.data.data || [];
            if (dateValue.length > 0) {
              let fun = dateValue[0].final_status || null;
              if (fun == "review_and_approved") {
                setReview(true);
              } else {
                setReview("");
              }
            }
            setLoading(false)
            if(dateValue.length == 0){
                setLoading(false)
            }
          })
          .catch((err) => {
            setLoading(false)
            console.log(err?.response?.data, "Error");
          });
      }

      useEffect(() => {
        if(url)getAllData()
      },[url,value,hasFilter])


  return { data, isLoading, review,getAllData,status };
}

export default useFetchPreReport